<template>
  <div class="mb-4">

    <!--#region -- Content ---->

    <!--#region SFDC Synchronization Real Data-->
    <div class="caption-label-hide d-flex" style="margin-left: -17px;">
      <div class="caption-label">
        <b-badge style="margin-right: 10px;" v-if="sfdcDemoLoans" variant="primary">{{sfdcDemoLoans.length}}</b-badge>
        <b-badge style="margin-right: 10px;" v-else variant="primary">0</b-badge>
        Salesforce Demo Loans
        <b-button v-if="sfdcDemoLoans !== null && _.size(sfdcDemoLoans) > 0"
                  v-b-toggle.collapseDemoLoans
                  variant="outline-primary"
                  class="text-primary text-left"
                  style="background-color: white; border: none;">
          <b-icon :icon="isCollapsed ? 'chevron-down' : 'chevron-up'"></b-icon>
        </b-button>
        <!--
          <div>
        <b-alert v-if="!sfdc_demo_loans_loading" show dismissible variant="primary">
          Click to expand the <b>Salesforce Demo Loans </b>details.
        </b-alert>
      </div>
        -->
      </div>
    </div>

    <b-collapse id="collapseDemoLoans" @shown="onShown" @hidden="onHidden" accordion="Salesforce Demo Loans" role="tabpanel">

      <div style="padding-top: 10px;" v-if="sfdcDemoLoans !== null && _.size(sfdcDemoLoans) > 0">
        <b-table :fields="sfdcDemoLoanFields" :items="sfdcDemoLoans"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <!-- https://localhost:8080/opportunity/demo-loan/id/a0ZEi0000022XpxMAE-->
          <template #cell(ID)="data">
            <a class="link"
               target="_blank"
               :href="safeUrl(`${ frontEndUrlToUse }opportunity/demo-loan/id/${ data.item.ID }`)">
              {{ data.item.ID }}
            </a>
          </template>

        </b-table>
      </div>
    </b-collapse>

    <!--#endregion-->
    <!-- #endregion Modal-->
  </div>
</template>

<script>
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'sfdc-demo-loans',
    props: {
      prop_sfdc_demo_loans: {
        default: null
      },
      prop_user_sites: {
        default: null
      },
      prop_user: {
        default: null
      },

    },
    data: function () {
      return {
        isRouterAlive: true,
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        sfdcDemoLoans: null,
        sfdcDemoLoansOriginal: null,
        fixModel: true,
        fixCustomizationPn: "Customization",
        basicInfo: null,
        loginUser: null,
        userSites: null,
        actionEnable: false,
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        createBy: null,
        searching: false,
        noneSelectedHint: '',
        sfdcDemoLoanFields: [
          { key: 'ID', label: 'ID', thClass: 'align-middle', sortable: true },
          //{ key: 'ACCOUNT_NAME', label: 'ACCOUNT_NAME', thClass: 'align-middle', sortable: true },
          //{ key: 'OPPORTUNITY_NAME', label: 'OPPORTUNITY_NAME', thClass: 'align-middle', sortable: true },
          { key: 'BUSINESS_POTENTIAL__C', label: 'Business Potential', thClass: 'align-middle', sortable: true },
          { key: 'STATUS__C', label: 'Status', thClass: 'align-middle', sortable: true },

          //{ key: 'customization_sku_id', label: 'Customization SKU ID', thClass: 'align-middle', sortable: true },
          { key: 'LOAN_PERIOD__C', label: 'Loan Period', thClass: 'align-middle', sortable: true },

          {
            key: 'DESIRED_RECEIVING_DATE__C', label: 'Desired Receive Date',
            thClass: 'align-middle',
            //tdClass: 'min-w-90',
            sortable: true
          },
          { key: 'UNIT_RETURNED_DATE__C', label: 'Returned Date', thClass: 'align-middle', sortable: true },
          {
            key: 'RETURNED_RESPONSIBILITIES__C', label: 'Returned Responsibilities',
            thClass: 'align-middle',
            //tdClass: 'min-w-90',
            sortable: true
          },
          { key: 'OWNER_NAME', label: 'Owner', thClass: 'align-middle', sortable: true },
        ],
        reloadBusy: false,
        isCollapsed: true,
      }
    },
    computed: {
      userFunctions() {
        return this.$session.get('user_functions');
      },
      userRoles() {
        return this.$session.get('user_roles');
      },

    },
    created() {
      let self = this;
      self.sfdcDemoLoans = self.prop_sfdc_demo_loans;
      self.sfdcDemoLoansOriginal = self.prop_sfdc_demo_loans;
      self.userSites = self.prop_user_sites;
      self.loginUser = self.prop_user;
      self.actionEnable = self.checkActionEnable();
      // console.log("SFDC Copo actionEnable:");
      // console.log(self.actionEnable);
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      onShown() {
        this.isCollapsed = false;
      },
      onHidden() {
        this.isCollapsed = true;
      },

      checkActionEnable() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        if (self.loginUser === 'power') {
          return true;
        }

        // loginUser is gtc owner
        if (self.loginUser !== null && self.createBy !== null && self.loginUser === self.createBy) {
          return true;
        }
        if (self.userRoles !== null && _.size(self.userRoles) > 0) {
          if (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1 || _.indexOf(self.userRoles, 'ES_PM') > -1) {
            return true;
          }
        }
        if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
          if (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1) {
            return true;
          }
        }
        //login_user_name === ftie_page_obj.gtc_owner || login_user_name === 'power' || (userRoles !== null && userRoles.includes('Admin')))
        return false;
      },

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/framework-sfdc/SfdcDemoLoans.vue